import { IDT } from '../IDT';

let bindings: IDT.Pricing = {
    total: () => undefined,
    from: () => undefined
};

export const bindSitePricing = (pricing: IDT.Pricing | undefined) => {
    bindings = { ...bindings, ...pricing };
};

export const requestTotalFromSite = (request: IDT.TotalPriceRequest) => {
    return Promise.resolve(bindings.total(request));
};

export const requestFromPriceFromSite = (request: IDT.FromPriceRequest) => {
    return Promise.resolve(bindings.from(request));
};